import axios from "axios";
import React, { useEffect } from "react";
import logoIcon from "../../assests/Images/kangaroo.webp";
import { Box } from "@mui/material";
export const KrogerCallback = () => {

  const addKrogerCart = async ({ code = "", products = [] }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_KROGER_TOKEN_API_CALL_URL}?code=${code}&products=${products}`
      );
      if(response) {
        window.location.href = 'https://www.kroger.com/cart';
      }
    } catch (error) {
      console.log("Error is: ", error);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const products = params.get("products");
    addKrogerCart({ code, products });
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height:"80vh",
        py: 8,
        px: 2,
      }}
    >
      <Box
        sx={{
          fontSize: 60,
          color: "#ff007f",
          animation: "bounce 1s infinite",
          "@keyframes bounce": {
            "0%, 100%": { transform: "translateY(0)" },
            "50%": { transform: "translateY(-10px)" },
          },
        }}
      >
        <img
          src={logoIcon}
          style={{ width: "60px", height: "60px" }}
          alt="Loading"
        />
      </Box>

      <div
        style={{
          fontSize: "16px",
          fontWeight: "400",
          color: "#333",
          textAlign: "center",
          maxWidth: "400px",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        }}
      >

        Building your cart now…

      </div>
    </Box>
  )
};
